module.exports = __webpack_public_path__ + "static/media/31.b9699cb7.jpg";